import { useCallback, useEffect, useRef } from "react";

type UseMultiTapOptions = {
    taps?: number;
    delay?: number;
};

export const useMultiTap = (
    callback: () => void,
    { taps = 2, delay = 300 }: UseMultiTapOptions = {},
) => {
    const countRef = useRef(0);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const reset = useCallback(() => {
        countRef.current = 0;
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);

    useEffect(() => reset, [reset]);

    const handleTap = useCallback(() => {
        countRef.current += 1;

        // перезапускаємо вікно очікування
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            reset();
        }, delay);

        if (countRef.current >= taps) {
            // успіх — одразу викликаємо і скидаємо
            reset();
            callback();
        }
    }, [callback, delay, taps, reset]);

    return handleTap;
};
